export default function insertAt(list, index, item) {
  return list.slice(0, index).concat(item, list.slice(index));
}
